export const COMMUNITY = 'COMMUNITY';

export const COMMUNITY_IMAGES = 'COMMUNITY_IMAGES';

export const COMMUNITY_AGENT = 'COMMUNITY_AGENT';

export const COMMUNITY_DESCRIPTION = 'COMMUNITY_DESCRIPTION';

export const COMMUNITY_HIGHLIGHTS = 'COMMUNITY_HIGHLIGHTS';
